/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { BodyPrepareTaskResourceFileUploadTitle } from './bodyPrepareTaskResourceFileUploadTitle';
import type { BodyPrepareTaskResourceFileUploadDescription } from './bodyPrepareTaskResourceFileUploadDescription';
import type { BodyPrepareTaskResourceFileUploadCitation } from './bodyPrepareTaskResourceFileUploadCitation';

export interface BodyPrepareTaskResourceFileUpload {
  filename: string;
  content_type: string;
  filesize?: number;
  title?: BodyPrepareTaskResourceFileUploadTitle;
  description?: BodyPrepareTaskResourceFileUploadDescription;
  citation?: BodyPrepareTaskResourceFileUploadCitation;
}
